import { css } from "lit";

export const commerceCheckoutStyles = css`
  :host {
    display: block;
    color: var(--zui-text, #17212b);
    container-type: inline-size;
  }

  .shell {
    display: grid;
    gap: 20px;
    grid-template-columns: minmax(0, 1fr) minmax(260px, 340px);
    align-items: start;
  }

  .panel {
    border: 1px solid var(--zui-border, #dce3e8);
    border-radius: 16px;
    background: var(--zui-surface, #fff);
    padding: 20px;
  }

  h2,
  h3,
  p {
    margin-top: 0;
  }

  .muted {
    color: var(--zui-muted, #647482);
  }

  .stack {
    display: grid;
    gap: 12px;
  }

  .option {
    display: grid;
    gap: 3px;
    width: 100%;
    border: 1px solid var(--zui-border, #dce3e8);
    border-radius: 12px;
    background: #fff;
    color: inherit;
    padding: 12px;
    text-align: left;
    cursor: pointer;
  }

  .option[aria-pressed="true"] {
    border-color: var(--zui-accent, #347f92);
    box-shadow: 0 0 0 2px
      color-mix(in srgb, var(--zui-accent, #347f92) 20%, transparent);
  }

  .option:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .field {
    display: grid;
    gap: 6px;
  }

  input,
  textarea,
  select {
    box-sizing: border-box;
    width: 100%;
    border: 1px solid var(--zui-border, #cbd5dc);
    border-radius: 9px;
    padding: 10px 12px;
    font: inherit;
  }

  .actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 18px;
  }

  button.primary,
  button.secondary {
    border-radius: 999px;
    padding: 11px 18px;
    font: inherit;
    font-weight: 700;
    cursor: pointer;
  }

  button.primary {
    border: 0;
    color: #fff;
    background: var(--zui-accent, #347f92);
  }

  button.secondary {
    border: 1px solid var(--zui-border, #cbd5dc);
    color: inherit;
    background: #fff;
  }

  button:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }

  .error {
    border-radius: 10px;
    background: #fff1f1;
    color: #8b1a1a;
    padding: 12px;
  }

  .success {
    border-radius: 10px;
    background: #edf9f1;
    color: #176b38;
    padding: 12px;
  }

  .summary {
    position: sticky;
    top: 16px;
  }

  .line {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 7px 0;
  }

  .total {
    border-top: 1px solid var(--zui-border, #dce3e8);
    margin-top: 8px;
    padding-top: 14px;
    font-weight: 800;
  }

  #commerce-payment-element {
    min-height: 80px;
  }

  @container (max-width: 720px) {
    .shell {
      grid-template-columns: 1fr;
    }

    .summary {
      position: static;
    }
  }
`;
